module.exports = __webpack_public_path__ + "img/rechenzentrumspreis.7273fa23.jpg";